export default "__VITE_ASSET__CCVjjqJR__"